module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_8004.35381851.png";